import React, { useRef, useState, useEffect } from 'react';
import {
  Grid,
  MenuItem,
  TextField,
  InputLabel,
  Box,
  Card,
  Select,
} from '@mui/material';
import SimpleFooter from "examples/Footers/SimpleFooter";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainingCompanyRoutes";
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import Container from "@mui/material/Container";
import MKTypography from "components/MKTypography";
import Breadcrumbs from "examples/Breadcrumbs";
import Autocomplete from '@mui/material/Autocomplete';
import MKInput from 'components/MKInput';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
//   import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment-timezone';
import { getAllISOCodes, getAllInfoByISO } from 'iso-country-currency';
import DatePicker from "react-multi-date-picker";
import editRoutes from "trainingCompanyEditRoutes";
import { useParams } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              height: 'auto',
              p: 2,
              mx: { xs: 2, lg: 3 },
              mt: -8,
              mb: 4,
              backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
              backdropFilter: "saturate(200%) blur(30px)",
              boxShadow: ({ boxShadows: { xxl } }) => xxl,
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

function CustomMultipleInput({ openCalendar, value }) {
  return (
    <>
      <input type="hidden"
        onFocus={openCalendar}
        value={value}
        readOnly
      />
      <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: "40px" }} onClick={openCalendar}>Select Dates</MKButton>
    </>
  )
}

const Page = () => {
  const { trainingID } = useParams();
  const [trainingName, setTrainingName] = useState("");
  const [requirement, setRequirement] = useState("");
  const [toc, setToc] = useState("");
  const [expectedStartDate, setExpectedStartDate] = useState("");
  const [trainingDuration, setTrainingDuration] = useState("");
  const [modeOfTraining, setModeOfTraining] = useState("");
  const [trainingProposalState, setTrainingProposalState] = useState("");
  const [trainingType, setTrainingType] = useState("");
  const [classroomLocation, setClassroomLocation] = useState("");
  const [noOfParticipants, setNoOfParticipants] = useState("");
  const [audienceLevel, setAudienceLevel] = useState("");
  const [trainingExpectation, setTrainingExpectation] = useState("");
  const [totalTrainingBudget, setTotalTrainingBudget] = useState("");
  const [contactPerson, setContactPerson] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [emailId, setEmailId] = useState("");
  const [clients, setClients] = useState([]);
  const [clientName, setClientName] = useState([]);
  const [tsComment, setTsComment] = useState("");
  const [labNeeded, setLabNeeded] = useState("");
  const [validatityOfTraining, setValidatityOfTraining] = useState("");
  const [trainingSchedule, setTrainingSchedule] = useState("");
  const [trainingTiming, setTrainingTiming] = useState("");
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [timeZone, setTimeZone] = useState([]);
  const [currency, setCurrency] = useState('');
  const [clientOpen, setClientOpen] = useState(false);
  const [selectedCurrencyCountry, setSelectedCurrencyCountry] = useState('');

  const [userId, setUserId] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [technologyName, setTechnologyName] = useState([]);
  const [skillsName, setSkillsName] = useState([]);
  const [showLocationField, setShowLocationField] = useState(false);
  const [submitCompleted, setSubmitCompleted] = useState(false);

  const [trainingCompanyProfileCreate, setTrainingCompanyProfileCreate] = useState(false);
  const [emailVerified, setEmailVerified] = useState(false);
  const [mobVerified, setMobVerified] = useState(false);
  const [tcVerified, setTcVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [trainingData, setTrainingData] = useState([]);

  console.log("trainingID", trainingID);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/training-details-edit/${trainingID}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setTrainingData(data);
          setTrainingName(data.trainingName);
          setSkillsName(data.technology);
          setTechnologyName(data.technology ? data.technology.split(', ').join(', ') : '');
          setRequirement(data.requirements);
          setToc(data.tocAvailable);
          setLabNeeded(data.labNeededForTraining);
          setTrainingTiming(data.trainingTiming);
          setStartTime(data.startTime);
          setEndTime(data.endTime);
          setTimeZone(data.timeZone ? data.timeZone.split(', ').join(', ') : '');
          setTrainingType(data.trainingType);
          setModeOfTraining(data.trainingMode);
          setExpectedStartDate(data.expectedStartDate);
          setClassroomLocation(data.trainingLocations);
          setTrainingDuration(data.duration);
          setTrainingProposalState(data.trainingProposalState);
          setNoOfParticipants(data.totalParticipants);
          setAudienceLevel(data.audienceLevel);
          setTrainingExpectation(data.trainingExpectation);
          setCurrency(data.currency);
          setTotalTrainingBudget(data.totalTrainingBudget);
          setContactPerson(data.contactPerson);
          setMobileNumber(data.mobileNumber);
          setEmailId(data.email);
          setClients(data.clientName ? data.clientName.split(', ').join(', ') : '');
          setValidatityOfTraining(data.deadline);
          setTrainingSchedule(data.trainingSchedule ? data.trainingSchedule.split(', ') : []);
          setTsComment(data.trainingScheduleComment);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("trainingData", trainingData);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setSkillsName(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("skillsName", skillsName);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/client-details/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setClientName(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("clientName", clientName);


  const handleTechnologyChange = (event, newValue) => {
    const typedSkill = event.target.value;
    console.log("typedSkill@@@@@@@@@@@@@", typedSkill);
    if (typedSkill && !skillsName.includes(typedSkill)) {
      fetch(`${process.env.REACT_APP_API_URL}/api/skill-details/?q=${typedSkill}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setSkillsName([...skillsName, ...data]);
        })
        .catch((error) => {
          console.error(error);
        });
    }
    const formattedTechnology = newValue.map((option) => option).join(', ');

    // Set the formatted technology name
    setTechnologyName(formattedTechnology);
  };
  console.log("technology", technologyName);
  console.log("trainingName", trainingName);
  console.log("requirement", requirement);

  console.log("trainingDuration", trainingDuration);
  console.log("classroomLocation", classroomLocation);
  console.log("clientName", clientName);
  console.log("totalTrainingBudget", totalTrainingBudget);
  console.log("contactPerson", contactPerson);
  console.log("mobileNumber", mobileNumber);
  console.log("emailId", emailId);
  console.log("tsComment", tsComment);

  const [tocS3BucketURL, setTocS3BucketURL] = useState(null);

  useEffect(() => {
    let userName = localStorage.getItem("user");
    let id = localStorage.getItem("userId");
    let bucketURL = `trainingcompanyhub/${id}_${userName}`;
    setTocS3BucketURL(bucketURL);
  }, [])
  console.log("tocS3BucketURL", tocS3BucketURL);

  const handleTocChange = (e) => {
    setToc(e.target.value);
  };
  console.log("toc", toc);

  const [tocFile, setTocFile] = useState(null);

  const [tocError, setTocError] = useState(null);

  const tocFileInputRef = useRef(null);

  const handleUploadClick = () => {
    tocFileInputRef.current.click();
  };

  const handleTocUploadChange = (event) => {
    const selectedFile = event.target.files[0];
    const fileExtension = selectedFile.name.split('.').pop();

    if (selectedFile) {
      const allowedFormats = ['pdf', 'docx', 'xlsx', 'xls'];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        // Invalid format
        setTocError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 5 * 1024 * 1024) {
        setTocError("File size should be maximum 5mb.");
        return;
      }

      // Reset error if validation is successful
      setTocError(null);
      const renamedFile = new File([selectedFile], `${trainingName}_toc.${fileExtension}`, { type: selectedFile.type });
      setTocFile(renamedFile);
    }
  };

  console.log("toc", tocFile);

  const handleTrainingCompanyTocDownloadClick = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${tocS3BucketURL}/trainingpost/${trainingName}_toc`;
  };

  const handleLabNeededChange = (e) => {
    setLabNeeded(e.target.value);
  };
  console.log("labNeeded", labNeeded);

  const handleTrainingTimningChange = (e) => {
    setTrainingTiming(e.target.value);
  };
  console.log("trainingTiming", trainingTiming);

  const today = new Date().toISOString().split('T')[0];
  const handleExpectedStartDateChange = (e) => {
    setExpectedStartDate(e.target.value);
  };
  console.log("expectedStartDate", expectedStartDate);

  const handleValidatityOfTrainingChange = (e) => {
    setValidatityOfTraining(e.target.value);
  };
  console.log("validatityOfTraining", validatityOfTraining);

  const handlePreferredModeChange = (e) => {
    const selectedMode = e.target.value;
    setModeOfTraining(selectedMode);

    if (selectedMode === "Classroom") {
      setShowLocationField(true);
    } else {
      setShowLocationField(false);
    }
  };
  console.log("modeOfTraining", modeOfTraining);

  const handleTrainingTypeChange = (e) => {
    setTrainingType(e.target.value);
  };
  console.log("trainingType", trainingType);

  const handleTrainingProposalStateChange = (e) => {
    setTrainingProposalState(e.target.value);
  };
  console.log("trainingProposalState", trainingProposalState);

  const handleAudienceLevelChange = (e) => {
    setAudienceLevel(e.target.value);
  };
  console.log("audienceLevel", audienceLevel);

  const handleTrainingExpectationChange = (e) => {
    setTrainingExpectation(e.target.value);
  };
  console.log("trainingExpectation", trainingExpectation);

  const handleTrainingScheduleChange = (selectedDates) => {
    const formattedDates = selectedDates.map((date) => {
      return date.format('YYYY-MM-DD');
    });

    setTrainingSchedule(formattedDates);
  };
  console.log("trainingSchedule", trainingSchedule);

  const handleStartTimeChange = (event) => {
    setStartTime(event.target.value);
  };
  console.log("startTime", startTime);

  const handleEndTimeChange = (event) => {
    setEndTime(event.target.value);
  };
  console.log("endTime", endTime);

  const timeZones = moment.tz.names();

  const handleTimeZoneChange = (newValue) => {

    const formattedTimeZone = newValue.map((option) => option).join(', ');

    // Set the formatted technology name
    setTimeZone(formattedTimeZone);
  };
  console.log("timeZone", timeZone);


  const onSubmitClick = (e) => {
    setLoading(true);
    console.log("trainingSchedule", trainingSchedule);
    const data = {
      trainingCompanyUserID: userId,
      trainingName: trainingName,
      trainingCompanyName: companyName,
      technology: technologyName,
      requirements: requirement,
      tocAvailable: toc,
      TOCURL: tocS3BucketURL,
      expectedStartDate: expectedStartDate,
      duration: trainingDuration,
      trainingMode: modeOfTraining,
      trainingType: trainingType,
      trainingProposalState: trainingProposalState,
      trainingLocations: classroomLocation,
      totalParticipants: noOfParticipants,
      trainingTiming: trainingTiming,
      startTime: startTime,
      endTime: endTime,
      timeZone: timeZone,
      labNeededForTraining: labNeeded,
      clientName: clients,
      audienceLevel: audienceLevel,
      trainingExpectation: trainingExpectation,
      currency: currency,
      totalTrainingBudget: totalTrainingBudget,
      contactPerson: contactPerson,
      mobileNumber: mobileNumber,
      email: emailId,
      trainingSchedule: trainingSchedule,
      trainingScheduleComment: tsComment,
      deadline: validatityOfTraining,
      status: "Active"
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/edit-training-post/${trainingID}/`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok && tocFile) {
          const formData = new FormData();
          formData.append('files', tocFile);

          console.log("formData", formData);
          console.log("s3BucketURL", tocS3BucketURL);

          fetch(`${process.env.REACT_APP_API_URL}/api/upload/${tocS3BucketURL}/trainingpost/`, {
            method: 'POST',
            body: formData,
          })
            .then(response => response.json())
            .then(data => {
              console.log(data);
            })
            .catch(error => {
              console.error('Error uploading file:', error);
            });
          console.log("Toc uploaded successfully");
          setSubmitCompleted(true);
          setLoading(false);
        } else if (response.ok) {
          setSubmitCompleted(true);
        } else {
          setSubmitCompleted(false);
          throw new Error("Profile is not created. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const handleCountryCurrencyChange = (event) => {
    const selectedISO = event.target.value;
    setSelectedCurrencyCountry(selectedISO);

    const currencyInfo = getAllInfoByISO(selectedISO);
    setCurrency(`${currencyInfo.currency} (${currencyInfo.symbol})`);
  };

  console.log("currency", currency);

  const handleClientsChange = (event, newValue) => {
    const typedClient = event.target.value;
    console.log("typedClient@@@@@@@@@@@@@", typedClient);
    if (typedClient && !clientName.includes(typedClient)) {
      fetch(`${process.env.REACT_APP_API_URL}/api/client-details/?q=${typedClient}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          setClientName([...clientName, ...data]);
        })
        .catch((error) => {
          console.error(error);
        });
    }

    const formattedClients = newValue.map((option) => option).join(', ');

    setClients(formattedClients);
    setClientOpen(false);
  };
  console.log("clients", clients);

  const handleClientOpen = () => {
    setClientOpen(true);
  };

  const handleClientClose = () => {
    setClientOpen(false);
  };

  const DialogProfileClose = () => {
    // setSubmitCompleted(false);
    window.location.href = '/app/trainingcompanydashboard';
  };

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    setUserId(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/training-companyprofile-filter/${id}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setCompanyName(data.companyName);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId")]);

  console.log("companyName", companyName);
  console.log("userId", userId);

  const handleCancelClick = (e) => {
    window.location.href = '/app/trainingcompanydashboard';
  };

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    setUserId(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setEmailVerified(data.is_verified);
          setMobVerified(data.is_verified_mobile);
          setTcVerified(data.is_verified_tc);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("token")]);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/trainingcompanyprofileuidexists/${id}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.exists === false && mobVerified === true && tcVerified === true && emailVerified === true) {
          setTrainingCompanyProfileCreate(true);
          window.location.href = "/app/trainingcompanyprofile";
        } else {
          setTrainingCompanyProfileCreate(false);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId")]);
  console.log("trainingCompanyProfileCreate", trainingCompanyProfileCreate);

  return (
    <>
      <LoadingOverlay loading={loading}>
        <IdleTimeOutHandler />
        <DefaultNavbar
          routes={trainingCompanyProfileCreate ? routes : editRoutes}
          sticky
        />
        <Card
          sx={{
            height: 'auto',
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Dialog
            open={submitCompleted}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Fantastic News!
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Your training has been successfully posted.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
              <MKButton onClick={() => { setSubmitCompleted(false); DialogProfileClose(); }} varaint="gradient" color="info" size="small" autoFocus>
                OK
              </MKButton>
            </DialogActions>
          </Dialog>
          <Container maxWidth="sm">
            <form>
              <Grid container style={{ marginTop: "130px" }} spacing={2}>
                <Grid item xs={12}>
                  <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Training Post</span> }]} />
                </Grid>
                <Grid container item spacing={2}>
                  <Grid item xs={4}>
                    {/* <div> */}
                    <TextField
                      label="Training Name *"
                      variant="outlined"
                      // fullWidth
                      style={{ width: "410px", minHeight: '44px' }}
                      value={trainingName}
                      onChange={(e) => {
                        setTrainingName(e.target.value);
                      }}
                    />
                    {/* </div> */}
                  </Grid>
                  <Grid item xs={4}>
                    {/* <div> */}
                    <Autocomplete
                      multiple
                      id="technology-autocomplete"
                      options={skillsName}
                      value={Array.isArray(technologyName) ? technologyName : technologyName.split(', ')} // Convert string to array
                      getOptionLabel={(option) => option}
                      freeSolo
                      renderTags={(value, getTagProps) =>
                        value.map((option, tagIndex) => (
                          <span key={tagIndex} {...getTagProps({ index: tagIndex })}>
                            {option}
                          </span>
                        ))
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Technology *"
                          variant="outlined"
                          defaultValue={technologyName ? technologyName : ''}
                          style={{ width: "100%", minHeight: '44px' }}
                        // fullWidth
                        />
                      )}
                      onChange={(event, value) => handleTechnologyChange(event, value)}
                    />
                    {/* </div> */}
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  {/* <div> */}
                  <TextField
                    label="Requirement *"
                    multiline
                    rows={4}
                    variant="outlined"
                    style={{ width: "410px" }}
                    // fullWidth
                    value={requirement}
                    onChange={(e) => {
                      setRequirement(e.target.value);
                    }}
                  />
                  {/* </div> */}
                </Grid>
                <Grid item xs={4} style={{ marginTop: "50px" }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Grid container alignItems="center">
                      <Grid item xs={12} sm={3}>
                        <MKTypography style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }} variant="body2" fontWeight="regular" color="text">
                          Is TOC available? *
                        </MKTypography>
                      </Grid>
                      <Grid item>
                        <FormControl component="fieldset" style={{ marginLeft: '30px' }}>
                          <RadioGroup row aria-label="toc" name="toc" value={toc} onChange={handleTocChange}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                              <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                      {toc === 'yes' && (
                        <>
                          <Grid item xs={4} style={{ marginTop: "-40px", marginLeft: "280px" }}>
                            <MKTypography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }}>
                              TOC format in .pdf, .docx, .xlsx, .xls
                            </MKTypography>
                            <input
                              type="file"
                              id="toc-upload"
                              accept="pdf/*"
                              style={{ display: 'none' }}
                              ref={tocFileInputRef}
                              onChange={handleTocUploadChange}
                            />
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <label htmlFor="toc-upload">
                                <MKButton onClick={handleUploadClick} variant="gradient" color="info" size="small" style={{ whiteSpace: 'nowrap' }}>
                                  Upload TOC
                                </MKButton>
                              </label>
                              {tocFile && (
                                <>
                                  <div style={{ fontSize: '14px', marginLeft: "10px" }}>
                                    <span> {tocFile.name}</span>
                                  </div>
                                </>
                              )}
                              {tocError && (
                                <>
                                  <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                                    {tocError}
                                  </MKTypography>
                                </>
                              )}

                            </div>
                          </Grid>
                        </>
                      )}
                      {toc === 'yes' && (
                        <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handleTrainingCompanyTocDownloadClick()}>
                          Download Training Partner TOC
                        </MKButton>
                      )}
                    </Grid>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Grid container alignItems="center">
                      <Grid item xs={12} sm={3}>
                        <MKTypography style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }} variant="body2" fontWeight="regular" color="text">
                          Is Lab Needed for Training ?
                        </MKTypography>
                      </Grid>
                      <Grid item>
                        <FormControl component="fieldset" style={{ marginLeft: '100px' }}>
                          <RadioGroup row aria-label="toc" name="toc" value={labNeeded} onChange={handleLabNeededChange}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                              <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={5} style={{ marginTop: "20px" }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Grid container alignItems="center">
                      <Grid item xs={12} sm={3}>
                        <MKTypography style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }} variant="body2" fontWeight="regular" color="text">
                          Training Timing *:
                        </MKTypography>
                      </Grid>
                      <Grid item>
                        <FormControl component="fieldset" style={{ marginLeft: '10px' }}>
                          <RadioGroup row aria-label="trainingTiming" name="trainingTiming" value={trainingTiming} onChange={handleTrainingTimningChange}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                              <FormControlLabel value="Less than 4 hours" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Less than 4 hours" />
                              <FormControlLabel value="4 hours" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="4 hours" />
                              <FormControlLabel value="8 hours" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="8 hours" />
                            </Box>
                          </RadioGroup>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid item xs={1.5} style={{ marginTop: "20px" }}>
                  {/* <div>                     */}
                  <TextField
                    label="Start Time *"
                    type="time"
                    value={startTime}
                    onChange={handleStartTimeChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300,
                    }}
                  />
                  {/* </div> */}
                </Grid>
                <Grid item xs={1} style={{ marginTop: "20px" }}>
                  {/* <div> */}
                  <TextField
                    label="End Time *"
                    type="time"
                    value={endTime}
                    onChange={handleEndTimeChange}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{
                      step: 300,
                    }}
                  />
                  {/* </div> */}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  {/* <div> */}
                  <Autocomplete
                    multiple
                    id="timeZone-autocomplete"
                    options={timeZones}
                    value={Array.isArray(timeZone) ? timeZone : timeZone.split(', ')} // Convert string to array
                    getOptionLabel={(option) => option}
                    freeSolo
                    renderTags={(value, getTagProps) =>
                      value.map((option, tagIndex) => (
                        <span key={tagIndex} {...getTagProps({ index: tagIndex })}>
                          {option}
                        </span>
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Training Time Zone *"
                        variant="outlined"
                        style={{ width: '410px' }}
                      // fullWidth
                      />
                    )}
                    onChange={(event, value) => handleTimeZoneChange(value)}
                  />
                  {/* </div> */}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  {/* <div> */}
                  <FormControl variant="outlined" style={{ width: '410px' }}>
                    <InputLabel id="taining-type-label">Training Type *</InputLabel>
                    <Select
                      labelId="traning-type-label"
                      label="Training Type"
                      // fullWidth
                      onChange={handleTrainingTypeChange}
                      value={trainingType}
                      style={{ minHeight: '44px' }}
                    >
                      <MenuItem value="Corporate">Corporate</MenuItem>
                      <MenuItem value="Individual">Individual</MenuItem>
                      <MenuItem value="Public Batch">Public Batch</MenuItem>
                      <MenuItem value="College Seminars">College Seminars</MenuItem>
                      <MenuItem value="Public Seminars">Public Seminars</MenuItem>
                    </Select>
                  </FormControl>
                  {/* </div> */}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  {/* <div> */}
                  <FormControl variant="outlined" style={{ width: '410px' }}>
                    <InputLabel id="preferred-mode-label">Mode Of Training *</InputLabel>
                    <Select
                      labelId="preferred-mode-label"
                      label="Mode Of Training"
                      style={{ width: "410px" }}
                      // fullWidth
                      onChange={handlePreferredModeChange}
                      value={modeOfTraining}
                      style={{ minHeight: '44px' }}
                    >
                      <MenuItem value="Virtual">Virtual</MenuItem>
                      <MenuItem value="Classroom">Classroom</MenuItem>
                    </Select>
                  </FormControl>
                  {/* </div> */}
                </Grid>
                {showLocationField && (
                  <>
                    <Grid item xs={4} style={{ marginTop: "20px" }}>
                      {/* <div> */}
                      <TextField
                        label="Location of Classroom"
                        variant="outlined"
                        style={{ width: "410px" }}
                        // fullWidth
                        value={classroomLocation}
                        onChange={(e) => setClassroomLocation(e.target.value)}
                      />
                      {/* </div> */}
                    </Grid>
                  </>
                )}
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "30px" }}>
                  {/* <div> */}
                  <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>Expected Start Date *</InputLabel>
                  <MKInput
                    type="date"
                    id="expectedStart_date"
                    value={expectedStartDate || ""}
                    onChange={handleExpectedStartDateChange}
                    style={{ width: "410px" }}
                    placeholder="Expected Start Date"
                    inputProps={{ min: today }}
                    disabled={loading}
                  // fullwidth
                  />
                  {/* </div> */}
                </Grid>
                <Grid item xs={4} style={{ marginTop: "30px" }}>
                  {/* <div> */}
                  <TextField
                    label="Total Duration of Training (in hours)"
                    variant="outlined"
                    style={{ width: "410px" }}
                    // fullWidth
                    value={trainingDuration}
                    onChange={(e) => {
                      setTrainingDuration(e.target.value);
                    }}
                  />
                  {/* </div> */}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  {/* <div> */}
                  <FormControl variant="outlined" style={{ width: '410px' }}>
                    <InputLabel id="proposal-state-label">Training Proposal State *</InputLabel>
                    <Select
                      labelId="proposal-state-label"
                      label="Training Proposal State"
                      style={{ width: "410px" }}
                      // fullWidth
                      onChange={handleTrainingProposalStateChange}
                      value={trainingProposalState}
                      style={{ minHeight: '44px' }}
                    >
                      <MenuItem value="Confirmed">Confirmed</MenuItem>
                      <MenuItem value="Biding">Biding</MenuItem>
                    </Select>
                  </FormControl>
                  {/* </div> */}
                </Grid>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  {/* <div>                     */}
                  <TextField
                    label="Number of Participants"
                    variant="outlined"
                    style={{ width: "410px" }}
                    // fullWidth
                    value={noOfParticipants}
                    onChange={(e) => {
                      setNoOfParticipants(e.target.value);
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    type="number"
                  />
                  {/* </div> */}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  {/* <div> */}
                  <FormControl variant="outlined" style={{ width: '410px' }}>
                    <InputLabel id="audience-level-label">Audience level *</InputLabel>
                    <Select
                      labelId="audience-level-label"
                      label="Audience Level"
                      // fullWidth
                      onChange={handleAudienceLevelChange}
                      value={audienceLevel}
                      style={{ minHeight: '44px' }}
                    >
                      <MenuItem value="Fresher">Fresher</MenuItem>
                      <MenuItem value="Lateral">Lateral</MenuItem>
                      <MenuItem value="not Known">Not Known</MenuItem>
                    </Select>
                  </FormControl>
                  {/* </div> */}
                </Grid>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  {/* <div> */}
                  <FormControl variant="outlined" style={{ width: '410px' }}>
                    <InputLabel id="training-expectation-label">Training Expectation *</InputLabel>
                    <Select
                      labelId="training-expectation-label"
                      label="Training Expectation"
                      // fullWidth
                      onChange={handleTrainingExpectationChange}
                      value={trainingExpectation}
                      style={{ minHeight: '44px' }}
                    >
                      <MenuItem value="Beginners">Beginners</MenuItem>
                      <MenuItem value="Intermediate">Intermediate</MenuItem>
                      <MenuItem value="Experienced">Experienced</MenuItem>
                      {/* <MenuItem value="not Known">Not Known</MenuItem> */}
                    </Select>
                  </FormControl>
                  {/* </div> */}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  <FormControl variant="outlined" style={{ width: '410px' }}>
                    <InputLabel id="country-currency">Country - Currency *</InputLabel>
                    <Select
                      labelId="country-currency"
                      label="Country - Currency"
                      // fullWidth
                      onChange={handleCountryCurrencyChange}
                      value={selectedCurrencyCountry}
                      style={{ minHeight: '44px' }}
                    >
                      {getAllISOCodes().map((country) => (
                        <MenuItem key={country.iso} value={country.iso}>
                          {country.countryName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={4} style={{ marginTop: "20px", marginLeft: "5px" }}>
                  <MKTypography variant="body2" style={{ marginTop: "10px" }}>
                    <span>Currency: {currency}</span>
                  </MKTypography>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  <TextField
                    label="Total Training Budget *"
                    variant="outlined"
                    style={{ width: "410px" }}
                    // fullWidth
                    value={totalTrainingBudget}
                    onChange={(e) => {
                      setTotalTrainingBudget(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  <TextField
                    label="Contact Person *"
                    variant="outlined"
                    style={{ width: "410px" }}
                    // fullWidth
                    value={contactPerson}
                    onChange={(e) => {
                      setContactPerson(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  <TextField
                    label="Mobile Number *"
                    variant="outlined"
                    style={{ width: "410px" }}
                    // fullWidth
                    value={mobileNumber}
                    onChange={(e) => {
                      setMobileNumber(e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  <TextField
                    label="Email ID *"
                    variant="outlined"
                    // fullWidth
                    style={{ width: "410px" }}
                    value={emailId}
                    onChange={(e) => {
                      setEmailId(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "30px" }}>
                  <Autocomplete
                    multiple
                    id="clients-autocomplete"
                    options={clientName}
                    freeSolo
                    value={Array.isArray(clients) ? clients : clients.split(', ')} // Convert string to array
                    getOptionLabel={(option) => option}
                    freeSolo
                    renderTags={(value, getTagProps) =>
                      value.map((option, tagIndex) => (
                        <span key={tagIndex} {...getTagProps({ index: tagIndex })}>
                          {option}
                        </span>
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Clients *"
                        variant="outlined"
                        style={{ width: '410px', minHeight: '44px' }}
                      // fullWidth
                      />
                    )}
                    onChange={(event, value) => handleClientsChange(event, value)}
                  />
                </Grid>
                <Grid item xs={4} style={{ marginTop: "30px" }}>
                  <InputLabel style={{ marginLeft: '5px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>Validatity of this Proposal *</InputLabel>
                  <MKInput
                    type="date"
                    id="validatity_training"
                    value={validatityOfTraining || ""}
                    onChange={handleValidatityOfTrainingChange}
                    style={{ width: "410px" }}
                    placeholder="Validatity of Training"
                    inputProps={{ min: today }}
                  // fullwidth
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={4} style={{ marginTop: "30px" }}>
                  <MKTypography variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }}>
                    Training Schedule *
                    <DatePicker
                      multiple
                      id="selectedDates"
                      style={{ marginLeft: '20px' }}
                      render={<CustomMultipleInput />}
                      onChange={handleTrainingScheduleChange}
                      value={trainingSchedule}
                    // minDate={new Date()}
                    // maxDate={fbmaxDate}
                    />
                  </MKTypography>
                  {trainingSchedule.length > 0 && (
                    <MKTypography style={{ marginTop: '5px' }} color="text" variant="body2" fontWeight="regular">
                      <MKTypography variant="body2" fontWeight="regular" color="text" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }} component="span">
                        Selected Dates For Training:
                      </MKTypography>{' '}
                      {trainingSchedule.join(', ')}
                    </MKTypography>
                  )}
                </Grid>
                <Grid item xs={4} style={{ marginTop: "20px" }}>
                  <TextField
                    label="Comment about Training Schedule"
                    multiline
                    rows={2}
                    style={{ width: "410px" }}
                    variant="outlined"
                    // fullWidth
                    value={tsComment}
                    onChange={(e) => {
                      setTsComment(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>


              <div style={{ display: "flex", marginBottom: "10px", marginTop: "10px" }}>
                <MKButton variant="gradient" color="info" onClick={handleCancelClick}>
                  Cancel
                </MKButton>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "-50px",
                  marginBottom: "10px",
                }}
              >
                <MKButton variant="gradient" color="info" onClick={onSubmitClick}
                  disabled={!trainingName || !requirement || !toc || !trainingTiming || !startTime || !endTime || !timeZone || !technologyName || !modeOfTraining
                    || !expectedStartDate || !trainingProposalState || !audienceLevel || !trainingExpectation || !currency || !totalTrainingBudget
                    || !contactPerson || !mobileNumber || !emailId || !clients || !validatityOfTraining || !trainingSchedule}>
                  Submit
                </MKButton>
              </div>
            </form>
          </Container>
        </Card>
        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
            <SimpleFooter />
          </MKBox>
        </div>
      </LoadingOverlay>
    </>
  );
}

export default Page;